import React from "react";
import { useLocation } from "react-router-dom";

import { Link } from "#/components/Link";
import { Feature, useFeatures } from "#/contexts/FeaturesContext";
import { cn } from "#/lib/utils";

const linkItems = (
  organization_id: number,
  features: Record<Feature, boolean>,
) => {
  return [
    {
      path: `/`,
      name: "Início",
    },
    {
      path: `/news_articles`,
      name: "Monitoramento Tributário",
    },
    {
      path: `/theses`,
      name: "Biblioteca de teses",
    },
    {
      path: `/diagnoses`,
      name: "Diagnósticos",
    },
    features.show_petition_models
      ? {
          path: `/petition_models`,
          name: "Petições",
        }
      : false,
  ].filter(Boolean) as {
    path: string;
    name: string;
    component?: React.FC<{ organization: { id: number } }>;
  }[];
};

export function MainNav({ className, organization, ...props }) {
  const { features } = useFeatures();

  return (
    <nav
      className={cn(
        "flex items-center space-x-4 lg:space-x-6 font-sans",
        className,
      )}
      {...props}
    >
      {linkItems(organization.id, features).map((item, idx) => {
        return (
          <React.Fragment key={idx}>
            {item.component ? (
              <item.component organization={organization} />
            ) : (
              <NavButton item={item} />
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

export function NavButton({ item, highlightExact = false }) {
  const pathname = useLocation().pathname;

  return (
    <Link
      to={item.path}
      className={cn(
        "text-muted-foreground hover:text-primary text-sm font-medium transition-colors",
        pathname === item.path ||
          (!highlightExact &&
            item.path.length > 1 &&
            pathname.startsWith(item.path))
          ? "text-primary"
          : "",
      )}
    >
      {item.name}
    </Link>
  );
}
